import * as types from '../mutation-types'

import awards from '@/api/awards'
const state = {
  awards: []
}

const getters = {
  awards: (state) => {
    return state.awards
  }
}

// actions
const actions = {
  getAwards ({ commit, state }, { siteSource, limit, offset }) {
    commit(types.CLEAR_AWARDS)
    return new Promise((resolve, reject) => {
      awards.get(siteSource, limit, offset).then((response) => {
        const awards = response.data.result.awards
        awards.forEach((award) => {
          commit(types.ADD_AWARD, award)
        })
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  },
  createAward ({ commit }, data) {
    return new Promise((resolve, reject) => {
      awards.create(data).then((response) => {
        const award = response.data.result.award
        commit(types.ADD_AWARD, award)
        resolve(award)
      }, (error) => {
        reject(error)
      })
    })
  },
  giveProjectAward ({ commit }, { projectID, awardID }) {
    return new Promise((resolve, reject) => {
      awards.giveProjectAward(projectID, awardID).then((response) => {
        const project = response.data.result.project
        commit(types.ADD_PROJECT, project)
        resolve(project)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateAward ({ commit }, { awardID, data }) {
    return new Promise((resolve, reject) => {
      awards.update(awardID, data).then((response) => {
        const award = response.data.result.award
        resolve(award)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteAward ({ commit }, awardID) {
    return new Promise((resolve, reject) => {
      awards.delete(awardID).then(() => {
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.ADD_AWARD] (state, award) {
    state.awards.push(award)
  },
  [types.CLEAR_AWARDS] (state, award) {
    state.awards = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
